
import React from 'react';
import { connect } from 'react-redux';
import LoginLoadingScreen from './loginLoadingScreen';
import { setLoginPage, setUserDetails } from '../../General/Actions';
import LoginPageComponent from './LoginPage';
import RegisterPageComponent from './RegisterPageRoot';
import ForgetPasswordComponent from './ForgetPasswordRoot';
import ForgetUsernameComponent from './ForgetUsernamePage';
import AnimationWrapper from '../../Utils/animationWrapper.js';
import ForgetUserNameOtpSentToNumberComponent from './ForgetUserNameOtpSentToNumber.js';
import OTPSignInCustomerIdComponent from './OTPSignInCustomerIdPart.js';
import SigninWithOtpComponent from './SignInWithOtpPart.js';
import ChangeUsernameComponent from './ChangeUsername.js';
import BillPayCustomerIdComponent from './BillPayCustomerIdPart';
import BillPayAmountComponent from './BillPayAmountPart';
import BillPayTransactionComponent from './BillPayTransactionpart';
import ResetPasswordComponent from './ResetPassword';
import RechargePhoneNumComponent from './RechargePhoneNumPart';
import RechargeAmountComponent from './RechargeAmountPart';
import RechargeTransactionComponent from './RechargeTransactionPart';
import VoucherPhoneNumComponent from './VoucherPhoneNumPart';
import VoucherCodeComponent from './VoucherCodePart';
import VoucherTransactionComponent from './VoucherTransactionPart';
import ResetPasswordUsingLinkComponent from './ResetPasswordUsingLink';
import jwt from 'jwt-decode'


class LoginPageRootComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        //Sample url: http://localhost:3000/?id=55&type=resetPassword
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get('id');
        const type = queryParams.get('type');
        if (id) {
            const userDetails = jwt(id);
            if (userDetails && userDetails.USERNAME && userDetails.USERID) {
                this.props.setUserDetails("username", userDetails.USERNAME);
                this.props.setUserDetails("userid", userDetails.USERID);
                this.props.setUserDetails("resetPassCreateTime", userDetails.CREATETIME);
            }
            if (type == "resetPassword") {
                this.props.setLoginPage("pageName", "resetPasswordUsingLink");
                this.setState({
                    isLoading: false
                });
            }
        } else {
            this.props.setLoginPage("pageName", "login");
            this.setState({
                isLoading: false
            });
        }
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    render() {
        if (this.state.isLoading === true) {
            return (<LoginLoadingScreen />);
        } else {
            return (
                <div>
                    <div id="toastPopup" className="animated slideInRight d-none"></div>
                    {this.componentContent()}
                </div>
            );
        }
    }

    componentContent() {
        const loginPageOuterMainContainerStyle = { height: this.state.windowHeight + 'px' };
        return (
            <div id="loginPageOuterMainContainer" style={loginPageOuterMainContainerStyle}>
                <AnimationWrapper.switchTransition
                    switchTrigger={this.props.loginPage.pageName}
                    triggerValueForChild0="login"
                    triggerValueForChild1="register"
                    triggerValueForChild2="forgetUsername"
                    triggerValueForChild3="forgetPassword"
                    triggerValueForChild4="forgotUsernameOtpNumber"
                    triggerValueForChild5="changeUsername"
                    triggerValueForChild6="customerIdForOTP"
                    triggerValueForChild7="signInWithOTP"
                    triggerValueForChild8="customerIdForBillPay"
                    triggerValueForChild9="amountForBillPay"
                    triggerValueForChild10="transactionForBillPay"
                    triggerValueForChild11="phoneNumForRecharge"
                    triggerValueForChild12="amountForRecharge"
                    triggerValueForChild13="transactionForRecharge"
                    triggerValueForChild14="phoneNumForVoucher"
                    triggerValueForChild15="codeForVoucher"
                    triggerValueForChild16="transactionForVoucher"
                    triggerValueForChild17="resetPassword"
                    triggerValueForChild18="resetPasswordUsingLink"
                    classNames={{ enterActive: 'animated fadeIn', exitActive: 'notransition' }}

                >
                    <LoginPageComponent />
                    <RegisterPageComponent />
                    <ForgetUsernameComponent />
                    <ForgetPasswordComponent />
                    <ForgetUserNameOtpSentToNumberComponent />
                    <ChangeUsernameComponent />
                    <OTPSignInCustomerIdComponent />
                    <SigninWithOtpComponent />
                    <BillPayCustomerIdComponent />
                    <BillPayAmountComponent />
                    <BillPayTransactionComponent />
                    <RechargePhoneNumComponent />
                    <RechargeAmountComponent />
                    <RechargeTransactionComponent />
                    <VoucherPhoneNumComponent />
                    <VoucherCodeComponent />
                    <VoucherTransactionComponent />
                    <ResetPasswordComponent />
                    <ResetPasswordUsingLinkComponent />
                </AnimationWrapper.switchTransition>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        loginPage: state.loginPage,
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setUserDetails: function (key, payload) {
            dispatch(setUserDetails(key, payload))
        }
    }
}

const LoginPageRootComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginPageRootComponent)


export default LoginPageRootComponentContainer;